<template>
  <!-- -->
  <div class="employee-list">
    <employee-list-common ref="employeeListCommon" @query-list="queryList"/>
  </div>
</template>

<script>

import EmployeeListCommon from "@/views/h5/common/basedata/employee/EmployeeListCommon.vue";
import employeeApi from "@/api/normal/sys/employeeApi";
export default {

  name: "",
  components: {
    EmployeeListCommon
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
    // 查询职员列表
    queryList(searchInfo) {
      employeeApi.queryList(searchInfo).then(res => {
        this.$refs.employeeListCommon.setData(res)
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.employee-list{
  height: 100%;
}
</style>